import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Walk = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("circle", { cx: 14, cy: 4, r: 2, key: "k0" }),
        React.createElement("path", { d: "M16.535 10l-1.703-2.555a1.003 1.003 0 0 0-.516-.394l-3-1a.994.994 0 0 0-.559-.021l-4 1A1.001 1.001 0 0 0 6 8v4h2V8.781l2.93-.732L6.279 22h2.107l2.3-6.899L13 17.414V22h2v-5a.996.996 0 0 0-.293-.707l-2.563-2.563 1.491-4.474 1.532 2.299c.187.278.499.445.833.445h3v-2h-2.465z", key: "k1" })));
});
Walk.displayName = 'Walk';
export var WalkDimensions = { height: 24, width: 24 };
